// Tiny inline markdown renderer for chat (no external deps)
// Supports: **bold**, *italic*, `inline code`, ```fenced code```, lists, line breaks
import { useMemo } from "react";

function escapeHtml(s) {
  return s.replace(/[&<>"']/g, (c) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  })[c]);
}

function renderInline(s) {
  let out = escapeHtml(s);
  out = out.replace(/`([^`]+)`/g, "<code>$1</code>");
  out = out.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  out = out.replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, "<em>$1</em>");
  return out;
}

function toHtml(md) {
  const lines = md.split(/\r?\n/);
  const out = [];
  let inCode = false;
  let codeBuf = [];
  let listType = null;
  let listBuf = [];

  const flushList = () => {
    if (listBuf.length) {
      const tag = listType === "ol" ? "ol" : "ul";
      out.push(`<${tag}>${listBuf.map((l) => `<li>${renderInline(l)}</li>`).join("")}</${tag}>`);
      listBuf = [];
      listType = null;
    }
  };

  for (let line of lines) {
    if (line.match(/^```/)) {
      if (inCode) {
        out.push(`<pre><code>${escapeHtml(codeBuf.join("\n"))}</code></pre>`);
        codeBuf = [];
        inCode = false;
      } else {
        flushList();
        inCode = true;
      }
      continue;
    }
    if (inCode) { codeBuf.push(line); continue; }

    const ulMatch = line.match(/^[-*]\s+(.*)/);
    const olMatch = line.match(/^\d+\.\s+(.*)/);
    if (ulMatch) {
      if (listType !== "ul") flushList();
      listType = "ul";
      listBuf.push(ulMatch[1]);
      continue;
    }
    if (olMatch) {
      if (listType !== "ol") flushList();
      listType = "ol";
      listBuf.push(olMatch[1]);
      continue;
    }
    flushList();

    if (line.trim() === "") {
      out.push("");
    } else {
      out.push(`<p>${renderInline(line)}</p>`);
    }
  }
  flushList();
  if (inCode) out.push(`<pre><code>${escapeHtml(codeBuf.join("\n"))}</code></pre>`);
  return out.join("");
}

export function Markdown({ children, className = "" }) {
  const html = useMemo(() => toHtml(children || ""), [children]);
  return (
    <div className={`prose-chat ${className}`} dangerouslySetInnerHTML={{ __html: html }} />
  );
}
